import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AiFillGithub,
  AiFillInstagram,
  AiOutlineMail
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import Tilt from "react-parallax-tilt";
import myImg from "../../Assets/perfil-geral.png";

function Home2() {
  const data = new Date().getFullYear() - 2018;
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              DEIXA EU <span className="purple">ME APRESENTAR</span>
            </h1>
            <p className="home-about-body">
              Sou <b className="purple">Rogério Nascimento,</b> bacharel em sistemas de
              informação graduado em 2022, programador com mais de <b className="purple">{data} anos</b> de experiência, 
              especializado em <b className="purple">PHP, Node </b>e <b className="purple">Typescript</b>.
              <br />
              <br />
              Tenho uma sede constante por aprendizado e me esforço para me manter atualizado com as 
              mais recentes tecnologias e práticas de desenvolvimento.               
              Meu foco é não apenas aprimorar minhas habilidades, mas também me manter sempre ativo 
              no mercado, contribuindo para projetos inovadores e impactantes.              
              <br />
              <br />
              Sempre que possível, também aplico minha paixão por desenvolver projetos pessoais com
              <b className="purple"> React JS, React Native </b> e <b className="purple">Angular</b> 
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img style={{ maxHeight: "250px" }} src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>Me encontre em</h1>
            <p>
            Fique à vontade para entrar em <span className="purple">contato </span>comigo
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/RogerioNascimento-dev"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="mailto:rogerionascimento.dev@gmail.com"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineMail />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/rogerionascimento-dev/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/rogerio_nascimentt"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
